export default "__VITE_ASSET__zBbfmw$M__"